import { v4 } from 'uuid'

const getDeviceId = (): string => {
  const storedDeviceId = window.localStorage.getItem('device-id')
  if (storedDeviceId) return storedDeviceId
  return v4()
}

export default getDeviceId
